import React, { useContext, useEffect, useState } from "react";
import Button from "../../button/Button";
import { pdf, PDFDownloadLink } from "@react-pdf/renderer";
import PdfContent from "../../pdf/PdfContent";
import { orderHistory, orderModal } from "../../../theme/theme";
import { ReactComponent as PrimaryEye } from "../../../assets/images/svg/primaryEye.svg";
import { ReactComponent as DownloadArrow } from "../../../assets/images/svg/download.svg";

import * as XLSX from "xlsx";

import { AuthContext } from "../../../services/context/authContext/AuthContext";
import moment from "moment";

const OrderContent = (props) => {
  const user = useContext(AuthContext);

  const isAdmin = user?.role === "admin";
  const isAccountant = user?.role === "accountant";
  const { orders, index } = props;
  const order = orders[index];
  const [pdfIsLoaded, setPdfIsLoaded] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    setPdfIsLoaded(true);
  }, []);
  const downloadXlsx = async () => {
    setIsLoading(true);
    const wb = XLSX.read(order.encodedXlsx, { type: "base64" });
    /* generate XLSX file and send to client */
    await XLSX.writeFile(wb, `${order.invoiceId}.xlsx`);
  };

  const previewPdf = async () => {
    const instance = pdf();

    instance.updateContainer(<PdfContent order={order} />);
    const blob = await instance.toBlob();
    const reader = new window.FileReader();
    reader.readAsArrayBuffer(blob);
    reader.onloadend = function () {
      const arrayBufferData = reader.result && reader.result;
      const file =
        arrayBufferData &&
        new Blob([arrayBufferData], { type: "application/pdf" });
      if (file) {
        const fileUrl = URL.createObjectURL(file);
        window.open(fileUrl, "_blank");
      }
    };
  };

  return (
    <div className="pt-14 pb-12 px-5 tablet:px-10 flex flex-col ">
      {isAdmin && (
        <div className={"flex flex-col gap-6 mb-14"}>
          <div>
            <h2 className={orderHistory["titleGray"]}>Date</h2>
            <h2 className={orderHistory["titleBlack"]}>
              {moment(order.createdAt.toDate()).format("MMMM-DD-YYYY")}
            </h2>
          </div>
          <div>
            <h2 className={orderHistory["titleGray"]}>User</h2>
            <h2 className={orderHistory["titleBlack"] + " break-words"}>
              {order.createdBy}
            </h2>
          </div>
          <div>
            <h2 className={orderHistory["titleGray"]}>Company</h2>
            <h2 className={orderHistory["titleBlack"]}>{order.company}</h2>
          </div>
          <div>
            <h2 className={orderHistory["titleGray"]}>Price</h2>
            <h2 className={orderHistory["titleBlack"]}>
              $ {order.totalPrice.toFixed(2)}
            </h2>
          </div>
        </div>
      )}
      <h2>Download Files</h2>
      <div className="flex flex-col tablet:flex-row mt-6 tablet:mt-10 gap-5">
        <Button
          styleOverride={true}
          className={orderModal["previewPdfButton"]}
          icon={PrimaryEye}
          title={"Preview pdf"}
          onClick={() => {
            previewPdf().catch((err) => console.log(err));
          }}
        />
        <Button
          styleOverride={true}
          className={orderModal["downLoadPdfButton"]}
          icon={DownloadArrow}
          content={
            pdfIsLoaded ? (
              <PDFDownloadLink
                document={<PdfContent order={order} />}
                fileName={`${order.invoiceId}.pdf`}
              >
                {({ loading, error }) => {
                  if (loading) {
                    return " Loading pdf...";
                  } else if (error) {
                    return "pdf error";
                  } else {
                    return ".PDF";
                  }
                }}
              </PDFDownloadLink>
            ) : (
              "Loading..."
            )
          }
        />
        {(isAdmin || isAccountant) && (
          <Button
            styleOverride={true}
            className={orderModal["downLoadPdfButton"]}
            icon={DownloadArrow}
            isLoading={isLoading}
            title={".XLSX"}
            onClick={() => downloadXlsx().then(() => setIsLoading(false))}
          />
        )}
      </div>
    </div>
  );
};

export default OrderContent;
